<div class="modal-content container-fluid">
  <div class="modal-body p-0">
    <section *ngIf="loansList.length > 0" class="loans-section">

      <!-- ── Visible / paginated summary table ── -->
      <div class="card m-0">
         <lms-table-wrapper [config]="config">
          <table class="loans-table table table-striped table-borderless table-hover table-fixed w-100">
            <caption class="text-center">Branch loans summary</caption>
            <thead class="sticky-thead">
              <tr>
                <th scope="col">Branch name</th>
                <th scope="col">First name</th>
                <th scope="col">Surname</th>
                <th scope="col">ID number</th>
                <th scope="col">Loan date</th>
                <th scope="col">Loan status</th>
                <th scope="col">File no</th>
                <th scope="col">Loan no</th>
                <th scope="col">First DO date</th>
                <th scope="col">Capital</th>
                <th scope="col ">Term</th>
                <th scope="col">Installment</th>
                <th scope="col">Total repayment</th>
                <th scope="col">User name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let loan of loansList | paginate: config;" class="loan-row">
                <td data-label="Branch name">{{loan.branchName}}</td>
                <td data-label="First name">{{loan.firstName}}</td>
                <td data-label="Surname">{{loan.surname}}</td>
                <td data-label="ID number">{{loan.idNumber}}</td>
                <td data-label="Loan date">{{loan.loanDate | date}}</td>
                <td data-label="Loan status">
                  <span class="status-badge {{ getStatusClass(loan.loanStatus) }}">
                  {{loan.loanStatus}}
                </span>
                </td>
                <td class="text-center" data-label="File no">{{loan.fileNr}}</td>
                <td class="text-center" data-label="Loan no">{{loan.loanNumber}}</td>
                <td data-label="First DO date">{{loan.firstDebitOrderDate}}</td>
                <td data-label="Capital" class="amount">{{loan.capital | zaRcurrency}}</td>
                <td class="text-center" data-label="Term">{{loan.term}}</td>
                <td data-label="Installment" class="amount">{{loan.installment | zaRcurrency}}</td>
                <td data-label="Total repayment" class="amount">{{loan.totalRepayment | zaRcurrency}}</td>
                <td data-label="User name">{{loan.userName}}</td>
              </tr>
            </tbody>
          </table>
        </lms-table-wrapper>
      </div>

      <!-- ── Hidden full-detail table (Excel export source) ── -->
      <div class="export-table-wrapper" #TABLE>
        <table #table hidden="true">
          <caption>Branch loans results</caption>
          <thead>
            <tr>
              <th scope="col">Branch name</th>
              <th scope="col">Branch serial</th>
              <th scope="col">Client type</th>
              <th scope="col">Wage frequency</th>
              <th scope="col">File no</th>
              <th scope="col">Date of birth</th>
              <th scope="col">Time</th>
              <th scope="col">Payout method</th>
              <th scope="col">Repayment method</th>
              <th scope="col">Id number</th>
              <th scope="col">Bank name</th>
              <th scope="col">Bank account</th>
              <th scope="col">Bank branch number</th>
              <th scope="col">Employer name</th>
              <th scope="col">Insurance</th>
              <th scope="col">Loan date</th>
              <th scope="col">Loan status</th>
              <th scope="col">First name</th>
              <th scope="col">Surname</th>
              <th scope="col">Cellphone number</th>
              <th scope="col">First DO date</th>
              <th scope="col">Capital</th>
              <th scope="col">Term</th>
              <th scope="col">Net income</th>
              <th scope="col">Max affordability</th>
              <th scope="col">Max installment</th>
              <th scope="col">Loan number</th>
              <th scope="col">My benefit</th>
              <th scope="col">Installment</th>
              <th scope="col">Initiation fee</th>
              <th scope="col">Total repayment</th>
              <th scope="col">User name</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let loan of loansList">
              <td>{{loan.branchName}}</td>
              <td>{{loan.branchSerial}}</td>
              <td>{{loan.clientType}}</td>
              <td>{{loan.wageFrequency}}</td>
              <td>{{loan.fileNr}}</td>
              <td>{{loan.dateOfBirth | date}}</td>
              <td>{{loan.time}}</td>
              <td>{{loan.payoutMethod}}</td>
              <td>{{loan.repaymentMethod}}</td>
              <td>{{loan.idNumber}}</td>
              <td>{{loan.bankName}}</td>
              <td>{{loan.bankAccount}}</td>
              <td>{{loan.bank}}</td>
              <td>{{loan.employerName}}</td>
              <td>{{loan.insurance}}</td>
              <td>{{loan.loanDate | date}}</td>
              <td>{{loan.loanStatus}}</td>
              <td>{{loan.firstName}}</td>
              <td>{{loan.surname}}</td>
              <td>{{loan.cellphoneNumber}}</td>
              <td>{{loan.firstDebitOrderDate}}</td>
              <td>{{loan.capital | zaRcurrency}}</td>
              <td>{{loan.term}}</td>
              <td>{{loan.netIncome | zaRcurrency}}</td>
              <td>{{loan.maxAffordability | zaRcurrency}}</td>
              <td>{{loan.maxInstallment | zaRcurrency}}</td>
              <td>{{loan.loanNumber}}</td>
              <td>{{loan.myBenefit | zaRcurrency}}</td>
              <td>{{loan.installment | zaRcurrency}}</td>
              <td>{{loan.initiationFee | zaRcurrency}}</td>
              <td>{{loan.totalRepayment | zaRcurrency}}</td>
              <td>{{loan.userName}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ── Action buttons ── -->
      <div class="lms-action-footer">
        <button class="btn btn-action btn-export" (click)="exportLoansToExcel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
               fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          Export full report to Excel
        </button>

        <button class="btn btn-action btn-close-modal" type="button" (click)="close()">
          Close
        </button>
      </div>

    </section>
  </div>
</div>
